/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import moveEntityTemplate from '../admin/entity/move-entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import MoveEntityController from '../admin/entity/move-entity.controller';

export default angular.module('agrolog.api.siloGroup', [])
    .factory('siloGroupService', SiloGroupService)
    .name;

/*@ngInject*/
function SiloGroupService($q, $mdDialog, $document, types, agTypes, agUserService, siloService, entityService, alarmService) {

    var allSiloGroupAttributesKeys = [];

    for (var attrId in agTypes.attributes.baseAsset) {
        var attr = agTypes.attributes.baseAsset[attrId];
        allSiloGroupAttributesKeys.push(attr);
    }
    for (attrId in agTypes.attributes.siloGroup) {
        attr = agTypes.attributes.siloGroup[attrId];
        allSiloGroupAttributesKeys.push(attr);
    }

    var positionAttributeKeys = [];
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionX);
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionY);


    var service = {
        saveSiloGroup: saveSiloGroup,
        moveSiloGroupDialog: moveSiloGroupDialog,
        getSiloGroup: getSiloGroup,
        getSiloGroupSilos: getSiloGroupSilos,
        getSiloGroupAssets: getSiloGroupAssets,
        getSiloGroupMapAssets: getSiloGroupMapAssets,
        deleteSiloGroup: deleteSiloGroup
    }

    return service;

    function saveSiloGroup(siloGroup, parentEntityId) {
        var deferred = $q.defer();
        var assign = !siloGroup.id.id;
        entityService.saveRelatedEntity(siloGroup, parentEntityId, allSiloGroupAttributesKeys).then(
            function success(siloGroup) {
                if (assign) {
                    agUserService.assignAssetToCustomer(siloGroup).then(
                        (siloGroup) => {
                            deferred.resolve(siloGroup);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(siloGroup);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function moveSiloGroupDialog($event, siloGroup, parentEntityId) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }

        var placeholderText = 'ag.silo-group.select-move-target-text';
        var notFoundText = 'ag.silo-group.move-target-not-found-text';
        var requiredText = 'ag.silo-group.move-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.site];

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: MoveEntityController,
                    controllerAs: 'vm',
                    templateUrl: moveEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        parentEntityId: parentEntityId,
                        entity: siloGroup,
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then(function () {
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function getSiloGroup(siloGroupId) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(siloGroupId, allSiloGroupAttributesKeys, agTypes.assetTypeTranslatePrefix).then(
            function success(siloGroup) {
                deferred.resolve(siloGroup);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloGroupSilos(siloGroupId, fetchAlarmsSeverity) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloGroupId, types.entityType.asset, [agTypes.assetType.silo], 1,
            ['maxTemperature', 'maxDeltaTemperature', 'maxMoisture', 'maxDeltaMoisture', 'hasMoistureCables', 'hasCO2Cables'], agTypes.assetTypeTranslatePrefix).then(
            function success(silos) {
                if (fetchAlarmsSeverity) {
                    var alarmsSeverityTasks = [];
                    for (var i=0;i<silos.length;i++) {
                        var silo = silos[i];
                        alarmsSeverityTasks.push(fetchAssetAlarmSeverity(silo));
                    }
                    $q.all(alarmsSeverityTasks).then(
                        function success(silos) {
                            deferred.resolve(silos);
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(silos);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloGroupAssets(siloGroupId, fetchAlarmsSeverity, assetWidgetType, providedAssetTypes = []) {
        var deferred = $q.defer();
        let assetTypes = providedAssetTypes.length > 0 ? providedAssetTypes : [agTypes.assetType.silo,
            agTypes.assetType.weatherStation,
            agTypes.assetType.aeration];
        let assetsAttributes = [agTypes.attributes.aeration.aerationType];
        if (assetWidgetType === agTypes.assetBrowserWidgetType.list) {
            assetsAttributes = assetsAttributes.concat([agTypes.attributes.silo.hasMoistureCables, agTypes.attributes.silo.hasCO2Cables]);
        }
        if (assetWidgetType === agTypes.assetBrowserWidgetType.dashboard) {
            assetsAttributes = assetsAttributes.concat([agTypes.attributes.silo.hasMoistureCables, agTypes.attributes.silo.hasCO2Cables, agTypes.attributes.silo.hasLevelIndicator, agTypes.attributes.silo.hasHeadSpaceSensor]);
        }
        entityService.getRelatedEntities(siloGroupId, types.entityType.asset, assetTypes, 1, assetsAttributes, agTypes.assetTypeTranslatePrefix).then(
            function success(assets) {
                if (fetchAlarmsSeverity) {
                    var alarmsSeverityTasks = [];
                    for (var i=0;i<assets.length;i++) {
                        var asset = assets[i];
                        alarmsSeverityTasks.push(fetchAssetAlarmSeverity(asset));
                    }
                    $q.all(alarmsSeverityTasks).then(
                        function success(siteAssets) {
                            var connectedSystemsTasks = [];
                            for (let i = 0; i < siteAssets.length; i++) {
                                if (siteAssets[i].type === agTypes.assetType.silo) {
                                    connectedSystemsTasks.push(siloService.getSiloConnectedSystems(siteAssets[i].id, fetchAlarmsSeverity));
                                } else {
                                    connectedSystemsTasks.push($q.when([]));
                                }
                            }
                            $q.all(connectedSystemsTasks).then(
                                function success(connectedSystemsData) {
                                    for (let i = 0; i < siteAssets.length; i++) {
                                        siteAssets[i].connectedSystems = (connectedSystemsData[i] && connectedSystemsData[i].length) ? connectedSystemsData[i] : null;
                                    }
                                    deferred.resolve(siteAssets);
                                },
                                function fail() {
                                    deferred.reject();
                                }
                            )
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(assets);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloGroupMapAssets(siloGroupId, fetchAlarmsSeverity) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloGroupId, types.entityType.asset, [agTypes.assetType.silo,
            agTypes.assetType.weatherStation,
            agTypes.assetType.aeration], 1, positionAttributeKeys, agTypes.assetTypeTranslatePrefix).then(
            function success(assets) {
                if (fetchAlarmsSeverity) {
                    var alarmsSeverityTasks = [];
                    for (var i=0;i<assets.length;i++) {
                        var asset = assets[i];
                        alarmsSeverityTasks.push(fetchAssetAlarmSeverity(asset));
                    }
                    $q.all(alarmsSeverityTasks).then(
                        function success(assets) {
                            var connectedSystemsTasks = [];
                            for (let i = 0; i < assets.length; i++) {
                                if (assets[i].type === agTypes.assetType.silo) {
                                    connectedSystemsTasks.push(siloService.getSiloConnectedSystems(assets[i].id, fetchAlarmsSeverity));
                                } else {
                                    connectedSystemsTasks.push($q.when([]));
                                }
                            }
                            $q.all(connectedSystemsTasks).then(
                                function success(connectedSystemsData) {
                                    for (let i = 0; i < assets.length; i++) {
                                        assets[i].connectedSystems = (connectedSystemsData[i] && connectedSystemsData[i].length) ? connectedSystemsData[i] : null;
                                    }
                                    deferred.resolve(assets);
                                },
                                function fail() {
                                    deferred.reject();
                                }
                            )
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(assets);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function fetchAssetAlarmSeverity(asset) {
        var deferred = $q.defer();
        alarmService.getHighestActiveAlarmInfo(asset.id.entityType, asset.id.id).then(
            function success(highestAlarm) {
                if (highestAlarm) {
                    asset.highestAlarmSeverity = highestAlarm.severity;
                    asset.highestAlarmStatus = highestAlarm.status;
                }
                deferred.resolve(asset);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteSiloGroup(siloGroupId) {
        var deferred = $q.defer();
        entityService.deleteRelatedEntity(siloGroupId, [types.entityType.asset]).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }


}
